import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaPhoneAlt, FaEnvelope, FaFacebookF } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";
import { siteInfo } from "../data/siteContent";
import styles from "./Footer.module.css";

const Footer = () => (
  <footer className={styles.footer}>
    <Container>
      <Row className="text-center text-md-start">
        <Col md={4} className={`mb-3 ${styles.contactInfo}`}>
          <p>
            <FaPhoneAlt />{" "}
            <a href={`tel:${siteInfo.phone}`} className={styles.link}>
              {siteInfo.phone}
            </a>
          </p>
          <p>
            <FaEnvelope />{" "}
            <a href={`mailto:${siteInfo.email}`} className={styles.link}>
              {siteInfo.email}
            </a>
          </p>
          <p>
            <IoLocationSharp /> {siteInfo.address}
          </p>
        </Col>

        <Col md={4} className={`mb-3 ${styles.socialSection}`}>
          <h5>Follow Us</h5>
          <p>
            <a
              href={siteInfo.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
            >
              <FaFacebookF /> Facebook
            </a>
          </p>
        </Col>
      </Row>

      <hr className={styles.divider} />

      <Row>
        <Col className="text-center">
          <p className={styles.copyright}>
            &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
          </p>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default Footer;
